export default __webpack_public_path__ + "imgs/fedbec6a2f7b4ddec08ee8d3672496cb.jpg";